<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h1>Stock Type</h1>
        <v-text-field
          filled
          data-cy="FormStockType-name"
          :label="$$t('name')"
          v-model="localStockType.name"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormStockType-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="$parent.isSaving"
            data-cy="FormStockType-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
export default {
  name: 'FormStockType',
  module: 'StockType',
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    StockType: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localStockType
      */
      localStockType: {},
    };
  },
  watch: {
    StockType() {
      this.localStockType = this.StockType;
    },
  },
  created() {
    this.localStockType = this.StockType;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localStockType);
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormStockType example

'''js
<FormStockType :StockType="StockType" />
'''
</docs>
